module.exports = __webpack_public_path__ + "static/media/toggel.e5a280f7.svg";